/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { useEffect } from 'react';
import RHFAutoComplete from 'src/components/elements/AutoComplete/RHFAutoComplete';
import { useForm } from 'react-hook-form';
import { useJobs } from 'src/hooks/query/jobs';
import { DiceJobsState, DiceViewRendererProps } from '../../types';
import { DiceCandidatesTable, DiceDetailsForm } from '../../components';

function Desktop(props: DiceViewRendererProps) {
  const {
    jobDetails,
    records,
    fetchingCandidates,
    filters,
    fetchCandidatesForDice,
    fetchJobDetails,
    onChangePagination,
    rowSelection,
    onRowSelectionChange,
    onRowClick,
  } = props;
  const {
    jobsLoading,
    jobsOptions,
    fetchJobs,
  } = useJobs({ enabled: false });

  const methods = useForm<DiceJobsState>();

  useEffect(() => {
    fetchJobs();
  }, []);

  return (
    <div className="p-10 py-10">
      <div className="w-full">
        <form>
          <div className="w-[300px]">
            <RHFAutoComplete
              name="jobs"
              control={methods.control}
              options={jobsOptions.map((option) => ({
                label: option.label,
                value: option.value.toString(), // Convert value to string here
              }))}
              loading={jobsLoading}
              placeholder="Search jobs"
              onSelectChange={fetchJobDetails}
            />
          </div>
        </form>
        <DiceDetailsForm
          jobTitle={jobDetails?.jobTitle}
          skills={jobDetails?.skills?.map((item: any) => item.name)}
          fetchCandidatesForDice={fetchCandidatesForDice}
        />
      </div>
      {
        records.length > 0
      && (
      <div className="w-full custom-shadow">
        <DiceCandidatesTable
          fetchingCandidates={fetchingCandidates}
          pagination={filters.pagination}
          onChangePagination={onChangePagination}
          records={records}
          rowSelection={rowSelection}
          onRowSelectionChange={onRowSelectionChange}
          onRowClick={onRowClick}
        />
      </div>
      )
      }
    </div>
  );
}

export default Desktop;
